export interface AttachmentResponseObject {
  attributes: Attachment;
  id: string;
  type: string;
}

export enum PreviewType {
  Audio = 'audio',
  Image = 'image',
  OfficeDoc = 'office',
  PDF = 'pdf',
  VideoBrightcove = 'brightcove',
  VideoMux = 'mux',
  VideoOther = 'video',
  VideoProcessing = 'processing',
}

export interface Attachment {
   // TODO: extension can sometimes be null (example: https://app.logrocket.com/3xwicr/boulder_prod/issue/23283051)
  extension: string | null;
  filename: string;
  height: number;
  mimetype: string;
  position: number;
  size: number;
  thumbnail_url: string;
  url: string;
  width: number;
  brightcove_account_id?: string;
  brightcove_video_id?: string;
  cdn_url?: string;
  is_processing?: boolean;
  mux_hls_url?: string;
  preview_type?: PreviewType;
  printui_settings?: {[key: string]: string};
  view_thumbnail_retina?: string;
}

export const isVideoType = (previewType: PreviewType): boolean => (
  [
    PreviewType.VideoBrightcove,
    PreviewType.VideoMux,
    PreviewType.VideoOther,
    PreviewType.VideoProcessing
  ].includes(previewType)
);
